import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TutorialState {
  /** Whether the tutorial tour is currently running */
  isRunning: boolean;
  /** Step index (react-joyride controlled) */
  stepIndex: number;
  /** Set of user IDs that have already completed the tutorial */
  completedByUser: string[];
  /** Start the tutorial */
  start: () => void;
  /** Stop / finish the tutorial */
  stop: () => void;
  /** Update step index */
  setStepIndex: (idx: number) => void;
  /** Mark the tutorial as completed for a specific user */
  markCompleted: (userId: string) => void;
  /** Check if a given user has completed the tutorial */
  hasCompleted: (userId: string) => boolean;
}

export const useTutorialStore = create<TutorialState>()(
  persist(
    (set, get) => ({
      isRunning: false,
      stepIndex: 0,
      completedByUser: [],
      start: () => set({ isRunning: true, stepIndex: 0 }),
      stop: () => set({ isRunning: false, stepIndex: 0 }),
      setStepIndex: (idx) => set({ stepIndex: idx }),
      markCompleted: (userId) => {
        const current = get().completedByUser;
        if (!current.includes(userId)) {
          set({ completedByUser: [...current, userId] });
        }
      },
      hasCompleted: (userId) => get().completedByUser.includes(userId),
    }),
    {
      name: 'tutorial-storage',
      partialize: (state) => ({ completedByUser: state.completedByUser }),
    },
  ),
);
